import { Popup } from "semantic-ui-react";
import { useMediaQuery } from "@react-hook/media-query";
import styles from "./favStyles.module.css";
import "semantic-ui-css/semantic.min.css";
import SVGDelete from "../../assets/svgComponents/Delete";
import { useUser } from "../../contexts/useUserData";
import { useState, useEffect } from "react";
import { useLayout } from "../../contexts/useLayoutContext";

interface propsType {
    index: number;
    deleteQuestion: Function;
    signalPopup: Function;
    closePopup: boolean;
}

export const PopupDeleteFavQuestions = (propsData: propsType) => {
    const { favQuestions } = useUser();
    const { menuOpen } = useLayout();
    const [statusPopup, setStatusPopup] = useState<boolean>(false);
    const isResponsive = useMediaQuery("only screen and (max-width: 768px)");

    useEffect(() => {
        if (propsData.closePopup) setStatusPopup(false);
    }, [propsData.closePopup]);

    useEffect(() => {
        if (isResponsive && !menuOpen) setStatusPopup(false);
    }, [menuOpen]);

    return (
        <Popup
            trigger={
                <button
                    type="button"
                    onClick={() => {
                        if (!statusPopup) {
                            setStatusPopup(true);
                            propsData.signalPopup(propsData.index);
                        } else {
                            setStatusPopup(false);
                        }
                    }}
                >
                    <SVGDelete />
                </button>
            }
            position={isResponsive ? "top left" : "right center"}
            on={"click"}
            open={statusPopup}
        >
            <div className={styles.confirmationContainer}>
                <p>¿Desea eliminar el favorito?</p>
                <div className={styles.confirmationButtons}>
                    <button
                        type="button"
                        onClick={() => {
                            setStatusPopup(false);
                        }}
                        className={styles.btnPrimary}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className={styles.btnDefault}
                        onClick={async () => {
                            await propsData.deleteQuestion(favQuestions![propsData.index!], propsData.index!);
                            setStatusPopup(false);
                        }}
                    >
                        Aceptar
                    </button>
                </div>
            </div>
        </Popup>
    );
};
